// app
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_FIRSTLOGIN = 'SET_FIRSTLOGIN'
export const SET_SLIDERSTATE = 'SET_SLIDERSTATE'
export const SET_LOCK_STATE = 'SET_LOCK_STATE'
//set province
export const SET_PROVINCE = 'SET_PROVINCE'
// user
export const SET_TOKEN = 'SET_TOKEN'
export const SET_ROLES = 'SET_ROLES'
export const SET_INTRODUCTION = 'SET_INTRODUCTION'
export const SET_NAME = 'SET_NAME'
export const SET_AREALIST = 'SET_AREALIST'
export const SET_MENULIST = 'SET_MENULIST'
export const SET_USERTYPE = 'SET_USERTYPE'
export const SET_REALNAME = 'SET_REALNAME'
export const SET_TAB = 'SET_TAB'
// permission
export const SET_ROUTERS = 'SET_ROUTERS'

// tagsview
export const ADD_VISITED_TAG = 'ADD_VISITED_TAG'
export const REMOVE_VISITED_TAG = 'REMOVE_VISITED_TAG'
export const CLOSE_OTHER_TAG = 'CLOSE_OTHER_TAG'
export const CLOSE_ALL_TAG = 'CLOSE_ALL_TAG'
export const SET_VIEWS = 'SET_VIEWS'

// times
export const SET_TIMES = 'SET_TIMES'